import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mm-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
